@if (type === 'array') {
  <em-select
    [subscriptSizing]="'dynamic'"
    [formControl]="inputControl"
    [errorMatcher]="errorMatcher"
    [multiple]="true"
    (selectionChange)="booleanChange($event)"
  >
    @for (operand of availableOperands; track operand) {
      <em-option [value]="operand.value">
        {{ operand.value }}
      </em-option>
    }
  </em-select>
} @else if (type === 'boolean') {
  <em-select
    [subscriptSizing]="'dynamic'"
    [formControl]="inputControl"
    [errorMatcher]="errorMatcher"
    (selectionChange)="booleanChange($event)"
  >
    @if (!hidePrefix) {
      <ng-container emPrefix>
        <mat-icon class="text-primary-300">{{
          inputControl.value ? 'check_box' : 'check_box_outline_blank'
        }}</mat-icon></ng-container
      >
    }
    <ng-container emSelectTrigger>{{
      (inputControl.value ? 'SHARED_LABEL_YES' : 'SHARED_LABEL_NO') | translate
    }}</ng-container>
    <em-option [value]="true">
      <mat-icon class="text-primary-300">check_box</mat-icon>
      {{ 'SHARED_LABEL_YES' | translate }}
    </em-option>
    <em-option [value]="false">
      <mat-icon class="text-primary-300">check_box_outline_blank</mat-icon>
      {{ 'SHARED_LABEL_NO' | translate }}
    </em-option>
  </em-select>
} @else if (type !== 'date') {
  <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
    <mat-label>
      @if (staticValuesOnly) {
        {{ 'SHARED_LABEL_STATIC_VALUE' | translate }}
      }
      @if (!staticValuesOnly) {
        {{ 'SHARED_LABEL_ATTRIBUTE' | translate }}
      }
    </mat-label>
    @if (!hidePrefix) {
      <ng-container matPrefix>
        @if (allowStaticValues) {
          <em-operand-icon
            class="px-[12px] inline-block"
            [operand]="controlValue"
            [operatorType]="type"
            [isCustom]="isCustom(controlValue?.value)"
          ></em-operand-icon>
        }
        @if (!allowStaticValues) {
          <em-operand-icon
            class="px-[12px] inline-block"
            [operand]="{type: 'attribute'}"
            [isCustom]="isCustom(controlValue?.value)"
          ></em-operand-icon>
        }
      </ng-container>
    }
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="optionSelected($event)"
    >
      @for (property of filteredPredefinedProperties$ | async; track property) {
        <mat-option [value]="property">
          <em-operand-with-icon
            [operand]="property"
            [isCustom]="false"
          ></em-operand-with-icon>
        </mat-option>
      }
      @if (filteredCustomProperties$ | async; as customProperties) {
        <mat-optgroup [label]="'SHARED_LABEL_CUSTOM_ATTRIBUTES' | translate">
          @for (property of customProperties; track property) {
            <mat-option [value]="property">
              <em-operand-with-icon
                [operand]="property"
                [isCustom]="true"
              ></em-operand-with-icon>
            </mat-option>
          }
        </mat-optgroup>
      }
    </mat-autocomplete>
    <input
      [type]="type === 'integer' ? 'number' : 'text'"
      matInput
      [formControl]="inputControl"
      [matAutocomplete]="auto"
      [errorStateMatcher]="errorMatcher"
      (blur)="inputBlur()"
      (focus)="inputFocused.next()"
    />
    <mat-error>
      @if (ngControl?.hasError('required')) {
        {{ 'VALIDATION_FIELD_REQUIRED' | translate }}
      }
    </mat-error>
  </mat-form-field>
}

<!-- Date Picker -->
@if (type === 'date') {
  <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
    <mat-label>{{ 'SHARED_LABEL_DATE' | translate }}</mat-label>
    <input
      type="text"
      matInput
      [formControl]="inputControl"
      [matDatepicker]="picker"
      [errorStateMatcher]="errorMatcher"
      (focus)="inputFocused.next()"
      (blur)="controlTouched()"
      (dateChange)="dateChanged($event)"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
}
